import React, { useEffect, useState } from 'react'
import { Breadcrumb, Button, Card, Col, Flex, Row, Space, Table, Tag, Typography } from 'antd'
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useNavigate, useParams } from 'react-router-dom';
import { protrackData } from '../../../Data';
import { apiCalls } from '../../../shared/Apis';
import { TableLoader } from '../../../shared';

const { Text } = Typography
const ProtrackSingleView = () => {
    let { trackId } = useParams()
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false)
    const [singleData, setSingleData] = useState(null)

    const SingleViewProject = async () => {
        setLoading(true)
        const result = await apiCalls?.ProjectTrackapi?.SingleViewProject(trackId)
        if (result)
            setSingleData(result)
        setLoading(false)
    }

    useEffect(() => {
        SingleViewProject();
    }, [trackId])

    const columns = [
        {
            title: 'Title',
            dataIndex: 'title',
            width: 150,
        },
        {
            title: 'Detail',
            dataIndex: 'detail',
            width: 150,
        },
    ];
    const data = [
        {
            key: '1',
            title: <Space direction='vertical' size={2}>
                <Text className='text-gray'>Client Name</Text>
                {
                    singleData ?
                        <Text>
                            {singleData?.data?.client?.firstName?.charAt(0).toUpperCase() + singleData?.data?.client?.firstName?.slice(1)}{' '}
                            {singleData?.data?.client?.lastName?.charAt(0).toUpperCase() + singleData?.data?.client?.lastName?.slice(1)}
                        </Text>
                        :
                        null
                }
            </Space>,
            detail: <Space direction='vertical' size={2}>
                <Text className='text-gray'>Client Email</Text>
                <Text>
                    {singleData?.data?.client?.email}
                </Text>
            </Space>,
        },
        {
            key: '2',
            title: <Space direction='vertical' size={2}>
                <Text className='text-gray'>Client Phone Number</Text>
                <Text>
                    {singleData?.data?.client?.phoneNo}
                </Text>
            </Space>,
        },
        {
            key: '3',
            title: <Space direction='vertical' size={2}>
                <Text className='text-gray'>Professional Name</Text>
                {
                    singleData ?
                        <Text>
                            {singleData?.data?.professional?.firstName?.charAt(0).toUpperCase() + singleData?.data?.professional?.firstName?.slice(1)}{' '}
                            {singleData?.data?.professional?.lastName?.charAt(0).toUpperCase() + singleData?.data?.professional?.lastName?.slice(1)}
                        </Text>
                        :
                        null
                }
            </Space>,
            detail: <Space direction='vertical' size={2}>
                <Text className='text-gray'>Professional Email</Text>
                <Text>
                    {singleData?.data?.professional?.email}
                </Text>
            </Space>,
        },
        {
            key: '4',
            title: <Space direction='vertical' size={2}>
                <Text className='text-gray'>Professional Phone Number</Text>
                <Text>
                    {singleData?.data?.professional?.phoneNo}
                </Text>
            </Space>,
        },
        {
            key: '5',
            title: <Space direction='vertical' size={2}>
                <Text className='text-gray'>Type</Text>
                {
                    singleData?.data?.type === '1' ?
                        <Text>Message</Text>
                        :
                        <Text>In Person</Text>
                }
            </Space>,
            detail: <Space direction='vertical' size={2}>
                <Text className='text-gray'>Date of Project</Text>
                {
                    singleData?.data?.dateOfProject === '1' ?
                        <Text>Urgent</Text>
                        :
                        <Text>Flexible</Text>
                }
            </Space>,
        },
        {
            key: '6',
            title: <Space direction='vertical' size={2}>
                <Text className='text-gray'>Start Date</Text>
                <Text>{singleData?.data?.date}</Text>
            </Space>,
            detail: <Space direction='vertical' size={2}>
                <Text className='text-gray'>End Date</Text>
                <Text>-</Text>
            </Space>,
        },
        {
            key: '7',
            title: <Space direction='vertical' size={2}>
                <Text className='text-gray'>Budget Min</Text>
                <Text>{singleData?.data?.budgetMin}</Text>
            </Space>,
            detail: <Space direction='vertical' size={2}>
                <Text className='text-gray'>Budget Min</Text>
                <Text>{singleData?.data?.budgetMax}</Text>
            </Space>,
        },
        {
            key: '8',
            title: <Space direction='vertical' size={2}>
                <Text className='text-gray'>Project Description</Text>
                <Text>{singleData?.data?.description}</Text>
            </Space>,
            detail: <Space direction='vertical' size={2}>
                <Text className='text-gray'>Services</Text>
                <Flex gap={5} wrap>
                    {
                        singleData?.services?.map((data) =>
                            <Tag className='brand-text border-brand'>
                                {data?.name}
                            </Tag>
                        )
                    }
                </Flex>
            </Space>,
        },
    ];

    return (
        <div>
            <Breadcrumb className='mb-3'
                separator=">"
                items={[
                    {
                        title: <Text className='cursor text-gray' onClick={() => navigate('/protrack')}>Project Tracking</Text>,
                    },
                    {
                        title: <Text className='fw-500'>
                            {
                                singleData ?
                                    <>
                                        Project ID # {singleData?.data?.id?.substr(0, 5)}
                                    </>
                                    : null
                            }
                        </Text>,
                    },
                ]}
            />
            <Card className='shadow-d radius-12 mb-3'>
                <Row gutter={[24, 24]}>
                    <Col span={24}>
                        <Space>
                            <Button className='border0 p-0 bg-transparent' onClick={() => navigate('/protrack')}>
                                <ArrowLeftOutlined />
                            </Button>
                            {
                                singleData ?
                                    <>
                                        <Text className='fw-500'>
                                            Project ID # {singleData?.data?.id?.substr(0, 5)}
                                        </Text>
                                        {
                                            singleData?.data?.status === 1 ? (
                                                <Text className='badge-cs pending fs-12'>Pending</Text>
                                            ) : singleData?.data?.status === 2 ? (
                                                <Text className='badge-cs active fs-12'>On-going</Text>
                                            ) : (
                                                <Text className='badge-cs inactive fs-12'>Complete</Text>
                                            )
                                        }
                                    </>
                                    :
                                    null
                            }
                        </Space>
                    </Col>
                    <Col span={24}>
                        <Table
                            size='large'
                            columns={columns}
                            dataSource={data}
                            scroll={{ x: 1000 }}
                            className='pagination'
                            showSorterTooltip={false}
                            rowHoverable={false}
                            showHeader={false}
                            pagination={false}
                            loading={
                                {
                                    ...TableLoader,
                                    spinning: loading
                                }
                            }
                        />
                    </Col>
                </Row>
            </Card>
        </div>
    )
}

export { ProtrackSingleView }
